import { encode as base64_encode } from "base-64";
import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import config from "../config";

class VehicleGroupStore {
  vehicleGroupVehicles = [];
  loading = false;
  assetList = [];
  vehicleArray = [];
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      vehicleGroupVehicles: observable,
      loading: observable,
      vehicleArray: observable,
      loadData: action,
      addData: action,
      getVehicleGroupData: action,
      getAssetData: action,
      deleteRecord: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ companyId }) {
    this.loading = true;

    var postData = { companyId: companyId, userId: null };

    // if(config.pythonReport==1){
    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/deviceGroup/getDeviceGroup", {
        params: postData,
      });
    this.vehicleGroupVehicles =
      response?.data?.DeviceGroupData[0]?.devicegroups;
    // }
    // else{

    //    const base64Input = await base64_encode(JSON.stringify(postData));
    //    var response = await postApi
    //   .getClient()
    //   .post("index.php?c=company&a=getalldata", "postData=" + base64Input);
    //   this.vehicleGroupVehicles = response?.data?.data[0]?.devicegroups;

    // }



    this.loading = false;
  }

  async addData(vehicleGroupData) {
    // var postData = vehicleGroupData;
    // if (config.pythonReport == 1) {
    // var vehicleGroupData = { postData };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient("")
      .post(
        config.NodeUrl + "/deviceGroup/updateDeviceGroups",
        { postData: vehicleGroupData }
      );
    // console.log("This is the response", response);
    // }
    // else {
    //   const base64Input = await base64_encode(JSON.stringify(postData));
    //   var response = await postApi
    //     .getClient()
    //     .post("index.php?c=devicegroup&a=vehicles", "postData=" + base64Input);
    // }

    return response;
  }

  async getVehicleGroupData(deviceGroupId, companyId) {
    var postData = {
      deviceGroupId: deviceGroupId,
      limit: 1,
      offset: 0,
      companyId: companyId,
    };
    // if (config.pythonReport == 1) {
    // var postData = {
    //   deviceGroupId: deviceGroupId,
    //   limit: 1,
    //   offset: 0,
    //   companyId: companyId,
    // };
    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/deviceGroup/getDeviceGroup", {
        params: postData,
      });
    this.vehicleArray =
      response.data.DeviceGroupData[0].devicegroups[0].vehicles;
    return response.data.DeviceGroupData[0].devicegroups[0];

    // }
    // else {
    //   const base64Input = await base64_encode(JSON.stringify(postData));
    //   var response = await postApi
    //     .getClient()
    //     .post("index.php?c=company&a=getalldata", "postData=" + base64Input);
    //   this.vehicleArray = response.data.data[0].devicegroups[0].vehicles;

    //   return response.data.data[0].devicegroups[0];

    // }

    // console.log("This is the resonse",response.data.GroupVehicles[0]);

    // console.log(vehicleArray)

  }

  // To get asset list
  async getAssetData({ companyId, userId, isadmin, search, isSelectAll }) {
    var postData = {
      companyId: companyId,
      userId: userId,
      isadmin: isadmin,
      search: search || "",
      isSelectAll: isSelectAll,
    };

    if (config.pythonReport == 1) {
      var response = await postApi
        .getClient()
        .post(config.NodeUrl + "/vehicle/devicevehiclelist", postData);

      this.assetList = response?.data?.data?.vehicles;

      return response?.data?.data?.vehicles;
    }
    else {
      console.log("This is the postdata", postData);
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post("index.php?c=vehicle&a=getVehicles", "postData=" + base64Input);

      this.assetList = response?.data?.data;
      return response?.data?.data;
    }
  }

  async deleteRecord({ deviceGroupId }) {
    // var postData = { tokenId: "", deviceGroupId: deviceGroupId };

    // if (config.pythonReport == 1) {
    var response = await postApi
      .getClient("")
      .delete(config.NodeUrl + "/deviceGroup/deleteDeviceGroup", {
        params: {
          deviceGroupId: deviceGroupId,
        },
      });

    // }
    // else {
    //   const base64Input = await base64_encode(JSON.stringify(postData));
    //   var response = await postApi
    //     .getClient()
    //     .post("index.php?c=deviceGrp&a=deviceDelete", "postData=" + base64Input);
    // }

    return response;
  }
}

export default VehicleGroupStore;
